import { Component } from 'react';

import { captureException, withScope } from '@sentry/nextjs';

import type { ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(e: Error): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    const expandedTags = {
      errorType: 'Runtime Error',
      errorOrigin: 'service',
      requestServerName: location.origin,
      path: location.pathname,
      method: '',
      responseCode: '',
    };

    withScope(scope => {
      scope.setTags(expandedTags);
      captureException(error);
    });
  }

  public render() {
    const children = this.props.children;
    const fallback = this.props.fallback;
    if (!this.state.hasError) return <>{children}</>;
    return <>{fallback}</>;
  }
}

export default ErrorBoundary;
